import { apiGet } from "./client";
import { buildListQuery, type CursorListParams } from "./pagination";

export interface PromptTemplate {
  kind: string;
  name: string;
  description: string;
  systemPrompt?: string;
  outputContract?: string;
  category?: string;
  enabled?: boolean;
  version: number;
  isActive: boolean;
  parsePattern: string;
  maxDuration: number;
  model?: string;
  allowedTools?: string[];
  disallowedTools?: string[];
  requiresCv: boolean;
  requiresProfile: boolean;
  requiresMemory: boolean;
  requiresDedup: boolean;
  requiresContext?: string[];
  changelog?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ListPromptsResponse {
  prompts: PromptTemplate[];
  total?: number;
  limit?: number;
  offset?: number;
  hasMore?: boolean;
  nextCursor?: string;
}

export async function listPrompts(
  params?: { category?: string } & CursorListParams,
): Promise<ListPromptsResponse> {
  return apiGet<ListPromptsResponse>(
    "/api/prompts",
    buildListQuery(params as Record<string, string | number | boolean | undefined | null>),
  );
}

export async function getPrompt(kind: string): Promise<PromptTemplate> {
  const res = await apiGet<PromptTemplate>(`/api/prompts/${kind}`);
  return res;
}